/**
 * アプリ内 returnUrl の安全な解釈。
 * 相対パスのみ許可。`//…` や `/auth/*` はフォールバック。
 */
export function safeAppReturnUrl(
  raw: string | null | undefined,
  fallback = '/',
): string {
  if (!raw) return fallback;
  if (!raw.startsWith('/') || raw.startsWith('//')) return fallback;
  if (raw.startsWith('/auth/login') || raw.startsWith('/auth/display-name')) {
    return fallback;
  }
  return raw;
}
